<template>
  <div class="ahj-search-container">
    <div class="search-and-map ahj-search-filter">
      <ahj-search-filter ref="searchFilter" v-on:ToggleSearchFilter="ToggleSearchFilter($event)"></ahj-search-filter>
    </div>
    <div class="search-and-map ahj-search-map" id="ahj-search-map">
      <component-mapview v-bind:filterToggled="this.filterToggled"></component-mapview>
    </div>
    <div class="ahj-table-sidebar" v-show="$store.state.showTable">
      <div class="table-info">
        <component-ahj-table-result-info class="ahj-table-result-info"></component-ahj-table-result-info>
        <component-ahj-table-pagination class="ahj-table-pagination"></component-ahj-table-pagination>
      </div>
      <div class="results-wrapper">
        <component-ahj-table-view></component-ahj-table-view>
      </div>
      <!-- /23331600579/Search_Results_300x250 -->
      <div id='div-gpt-ad-1765502581345-0' style='min-width: 300px; min-height: 250px;' class="sidebar-ad-300x250" aria-hidden="true"></div>
    </div>
    <b-modal id="webpage-throttle-modal">
        <template #modal-title>
            <h1 class='modal-title'>{{`Search Limit Reached`}}</h1>
        </template>
        <template v-if='!showMemberSupportText'>
          <p class='modal-text modal-primary-text'>Web users are limited to 100 searches per day.</p>
          <p class='modal-text modal-help-text'>If you're interested in API access, please contact <a href="mailto:membership@sunspec.org">membership@sunspec.org</a> to purchase membership.</p>
        </template>
        <template v-else>
          <p class='modal-text modal-member-help-text'>If your organization is already a SunSpec member, please create an account with your company email. </p>
          <p class='modal-text modal-member-help-text'>Contact support@sunspec.org if your account should have unlimited access.</p>
          <hr>
          <p class='modal-text modal-secondary-text' @click='showMemberSupportText = false'>Back</p>
        </template>
        <template #modal-footer>
            <b-button id="modal-close-button" pill variant='primary' @click="$bvModal.hide('webpage-throttle-modal')">
              OK
            </b-button>
        </template>
    </b-modal>
  </div>
</template>

<script>
import MapView from "../components/SearchPage/MapView.vue";
import AHJTableView from "../components/SearchPage/AHJTableView.vue";
import AHJSearchPageFilter from "../components/SearchPage/AHJSearchPageFilter.vue";
import AHJTablePagination from "../components/SearchPage/AHJTablePagination";
import AHJTableResultInfo from "../components/SearchPage/AHJTableResultInfo";
import "intro.js/minified/introjs.min.css";
import introJs from 'intro.js';
export default {
  data() {
    return {
      introStep: 0,
      runningTour: false,
      tutorial: null,
      filterToggled: true,
      showMemberSupportText: false,
      tutorialStarted: false, // Track if tutorial was already started in this mount
    }
  },
  created() { // called before 'mounted' is called for child components
    // hide the search results table on page load
    this.$store.commit("setShowTable", false);
  },
  mounted() {
    // If tutorial is explicitly requested via query param
    const tutorialRequested = this.$route.query.tutorial == 1;
    const tutorialCompleted = localStorage.getItem('tutorialCompleted');
    const explicitRequest = this.$route.query.restart === 'true' || !tutorialCompleted;
    
    if (tutorialRequested && !this.tutorialStarted && explicitRequest){
      this.tutorialStarted = true;
      // Only clear completion status if explicitly requested
      if (this.$route.query.restart === 'true') {
        localStorage.removeItem('tutorialCompleted');
      }
      this.$nextTick(() => {
        this.StartTutorial();
      });
    } else if (tutorialRequested && tutorialCompleted && !explicitRequest) {
      // Tutorial was completed and URL still has param, clean it up without restarting
      const url = new URL(window.location);
      url.searchParams.delete('tutorial');
      url.searchParams.delete('restart');
      window.history.replaceState({}, '', url);
    }
    // request GPT sidebar ad display
    this.requestAdDisplay();
  },
  beforeUnmount() {
    if (this.runningTour) {
      this.tutorial.exit();
    }
  },
  methods: {
    ToggleSearchFilter(isToggled) {
      this.filterToggled = isToggled;
    },
    StartTutorial() {
    let that = this;
    // attach click listener for the tour
    let clickEventLister = () => window.dispatchEvent(new Event(('resize')));
    document
        .querySelector('.ahj-search-filter')
        .addEventListener('click', clickEventLister);
    this.runningTour = true;
    this.tutorial = introJs();
        this.tutorial.setOptions({
          showStepNumbers: true,
          exitOnOverlayClick: false,
          showBullets: false,
          steps: [{
            title: 'Welcome',
            intro: '<p>Welcome, to the AHJ Registry! Here you can find all' +
                ' of the information necessary to successfuly apply for and receive ' +
                'a construction permit in the USA.</p>' +
                '<p>Let\'s take a quick tour through the search tool. For more information ' +
                'about the project, please visit our <a href="/#/about">About page.</a></p>'
          },{
            element: document.querySelector('.search-filter-form'),
            position: 'right',
            title: 'Finding Information',
            intro: '<p>Our feature-rich search tool helps users quickly find AHJ ' +
                'information related to different geographical regions.</p>' +
                '<p>Let\'s see how to best use it!</p>'
          },{
            element: document.querySelector('.search-filter-form  .search-field-group'),
            title: 'Addresses and Coordinates',
            position: 'right',
            intro: '<p>The search bar allows you to type any valid address or pair of' +
                ' latitude longitude coordinates to find AHJs who have jurisdiction' +
                ' over this area.</p> <p>For example, let\'s search with SunSpec\'s address.</p>'
          },{
            element: document.querySelector('.search-filter-form'),
            title: 'Try It Yourself!',
            position: 'right',
            intro: '<p>The best learning comes when you try yourself. Enter an address, or ' +
                'use the preloaded query, so we can see how to interpret search  results.</p>' +
                '<p>To continue, <b>click the search button.</b></p>'
          },{
            element: document.querySelector('.search-and-map'),
            title: 'Visualizing the Results',
            intro: '<p>Our interactive map is a great way to quickly see your search results.</p>' +
                '<p>Here\'s a quick guide to navigating this information:</p>' +
                '<ul>' +
                '<li>Your searched address is marked by a gray marker with an empty circle.</li>' +
                '<li>AHJ office locations are represented as blue markers with a building inside.</li>' +
                '<li>The red polygon shows the jurisdiction area for the currently selected AHJ. ' +
                'By default, the currently selected AHJ is the first entry in our table.</li>' +
                '</ul>'
          },{
            element: document.querySelector('.ahj-table-sidebar'),
            title: 'Quantitative Information',
            intro: '<p>Our table sidebar provides greater detail about the AHJs that matched your search. ' +
                'Each row contains high-level permitting information about a specific AHJ and has ' +
                'links to their specific AHJ page here on the registry. ' +
                'These AHJ pages contain more information about the AHJs such as contact information, permit submission methods, and fee structures. </p>' +
                '<p>When a large number of search results are found you can flip through table pages' +
                ' and download the results for batch processing.</p>'
          },{
            element: document.querySelector('.search-filter-form'),
            title: 'Advanced Searching',
            position: 'right',
            intro: '<p>Sometimes, a simple address search is not enough. ' +
                'Click on <em>show search options and filters</em> to see additional search features.</p>' +
                '<p>These advanced filters are great for those who need to find AHJs spanning a large' +
                ' region, or inversely, to find regions that have certain building requirements.</p>' +
                '<p>Take a second to look through the available search options for advanced filtering.</p>'
          },{
            title: 'Thank You',
            intro: '<p>The AHJ Registry has many exciting features for you to discover ' +
                'and we thank you for taking the time to work through this tutorial.</p>' +
                '<p>We hope you find the information that you\'re looking for. Details about the ' +
                'registry can be found on our <a href="/#/about">About Page</a>' +
                ' and additional tutorials will be coming out shortly!</p>'
          },]
        })
        .onbeforechange(function() {
          that.introStep++;
          switch (that.introStep) {
            case 4: // remove next button to prompt user to click 'Next'
              document.querySelector('.introjs-nextbutton').style.display = 'none';
              break;
          }
        }).onchange(function(element) {
      switch (element.id) {
        case "search-group": // fill in the search with an example query
          that.$refs.searchFilter.setDemoAddress();
          break;
      }
    })
        .onexit(() => {
          // remove click listener
          document
              .querySelector('.ahj-search-filter')
              .removeEventListener('click', clickEventLister);
          that.runningTour = false;
          // Mark tutorial as completed
          localStorage.setItem('tutorialCompleted', 'true');
          // Clean up URL without triggering navigation/remount
          if (that.$route.query.tutorial) {
            const url = new URL(window.location);
            url.searchParams.delete('tutorial');
            window.history.replaceState({}, '', url);
          }
        })
        .start();
    }
    ,
    requestAdDisplay() {
      window.googletag = window.googletag || { cmd: [] };
      window.googletag.cmd.push(function() {
        window.googletag.display('div-gpt-ad-1765502581345-0');
      });
    }
  },
  components: {
    "ahj-search-filter": AHJSearchPageFilter,
    "component-mapview": MapView,
    "component-ahj-table-result-info": AHJTableResultInfo,
    "component-ahj-table-pagination": AHJTablePagination,
    "component-ahj-table-view": AHJTableView,
  },
  watch: {
    /**
     * Listener to make the tutorial's 'Next' button reappear if search was made
     * @param newVal
     */
    '$store.state.showTable': function(newVal) {
      if (newVal && this.runningTour) {
        document.querySelector('.introjs-nextbutton').style.display = '';
      }
    },
    '$store.state.apiErrorInfo.status': function(newVal) {
      if (newVal === 429){
        // Emit event to show throttle modal
        this.$emit('show-throttle-modal');
      }
      if (newVal === 401){
        // Emit event to show login modal
        this.$emit('show-login');
      }
    }
  }
};
</script>

<style scoped>
.ahj-search-container {
  display: grid;
  grid-template-columns: auto fit-content(40%);
  /* height is calculated against the viewport minus the navbar height; the
     container does not add a top margin because the global #app padding-top
     (set in index.html) already reserves space for the fixed navbar. */
  height: calc(100vh - var(--navbar-height, 110px));
}

.ahj-search-filter {
  grid-column: 1;
  grid-row: 1 / 3;
}

.ahj-search-map {
  grid-column: 1;
  grid-row: 1 / 3;
  height: 100%;
  overflow: hidden;
}

.ahj-table-sidebar {
  grid-column: 2;
  grid-row: 1 / span 2;
  padding-left: 1em;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.table-info {
  display: grid;
  background: white;
}

.ahj-table-result-info {
  grid-column: 1;
}

.ahj-table-pagination {
  grid-column: 2;
  text-align: right;
}

.results-wrapper {
  flex: 1 1 auto;
  overflow: auto;
}

.modal-title {
  font-size: 1.6rem !important;
}

#modal-close-button {
  font-size: 1.2rem;
  font-weight: bold;
  color: ivory;
  width: 20%;
  line-height: 2rem;
  box-shadow: 1px 3px 2px #888888;
  outline-width: 0;
}

.modal-text {
  text-align: center;
}

.modal-primary-text {
  font-size: 1.3rem;
}

.modal-member-help-text {
  font-size: 1.2rem;
}

.modal-secondary-text {
  font-size: 1rem;
  cursor: pointer;
  text-decoration: underline;
  color: #196dd6;
  padding: 0;
  margin: 0;
}

hr {
  width: 70%;
}

@media (max-width: 1100px){
  .ahj-search-container {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr fit-content(40%);
  }

  .ahj-search-filter {
    grid-column: 1;
    grid-row: 1 / 2;
  }

  .ahj-search-map {
    grid-column: 1;
    grid-row: 1 / 2;
    min-height: 0;
  }

  .ahj-table-sidebar {
    grid-column: 1;
    grid-row: 2 / 3;
  }
}

/* Sidebar ad styling (always-visible placeholder) */
.sidebar-ad-300x250{
  grid-column: 2;
  width: 300px;
  height: 250px;
  margin: 1rem auto;
}
.sidebar-ad-300x250 .ad-placeholder-300{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e6e6e6;
  color: #333;
  font-family: Arial, sans-serif;
  font-size: 14px;
  border: 1px solid #222;
  border-radius: 4px;
}

@media (max-width: 1100px){
  .sidebar-ad-300x250 { display: none; }
}
</style>
